import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartSimple,
  faFilter,
  faCloudArrowDown,
} from "@fortawesome/pro-regular-svg-icons";
import ButtonAdd from "../atoms/ButtonAdd";
import EllipsesMenu, { OptionsMenuProps } from "../molecules/EllipsesMenu";
import { ButtonPrimary } from "../atoms/ButtonPrimary";

type NavbarFilterProps = {
  formComponents?: React.ReactNode;
  toggleDrawer?: () => void;
  toggleKpis?: () => void;
  setToggleButtonAdd?: (open: boolean) => void;
  exportData?: any;
  optionsMenu?: OptionsMenuProps[];
  showIcons?: boolean;
  showButtonAdd?: boolean;
  showPrimaryButton?: boolean;
  OnClickPrimaryButton?: () => void;
  filter?: boolean;
  showSeccundaryButton?: boolean;
  secudary_buttom_text?: string;
  secundary_button_onClick?: () => void;
  text_botton?: string;
  showFilterICon?: boolean;
};

const NavbarFilter: React.FC<NavbarFilterProps> = ({
  formComponents,
  toggleDrawer,
  toggleKpis,
  setToggleButtonAdd,
  exportData,
  optionsMenu,
  showIcons = true,
  showButtonAdd = true,
  showPrimaryButton = true,
  OnClickPrimaryButton,
  filter = false,
  text_botton,
  showSeccundaryButton = false,
  secundary_button_onClick,
  secudary_buttom_text,
  showFilterICon = true,
}) => {
  return (
    <div className="flex flex-col lg:flex-row w-full justify-between gap-4">
      <div className="flex flex-col md:flex-row w-full max-w-4xl md:items-center gap-4">
        <form
          action="#"
          method="GET"
          className="flex flex-col md:flex-row w-full gap-4"
        >
          {formComponents}
        </form>

        {showIcons && (
          <div className="flex items-center gap-4">
            {showFilterICon && (
              <button
                type="button"
                className=" p-2 text-gray-400 hover:text-gray-500"
              >
                <span className="sr-only">View KPIs</span>
                <FontAwesomeIcon
                  icon={faFilter}
                  className="h-6 w-6"
                  onClick={toggleDrawer}
                />
              </button>
            )}

            {!filter && (
              <button
                type="button"
                className=" text-gray-400 hover:text-gray-500"
              >
                <span className="sr-only">Export</span>
                <FontAwesomeIcon
                  icon={faCloudArrowDown}
                  className="h-6 w-6"
                  onClick={exportData}
                />
              </button>
            )}

            <button type="button" className="text-gray-400 hover:text-gray-500">
              <span className="sr-only">View KPIs</span>
              <FontAwesomeIcon
                icon={faChartSimple}
                className="h-6 w-6"
                onClick={toggleKpis}
              />
            </button>
          </div>
        )}
      </div>

      <div className="flex flex-wrap items-center justify-start lg:justify-end gap-2">
        {showButtonAdd && setToggleButtonAdd && (
          <ButtonAdd functionButton={() => setToggleButtonAdd(true)} />
        )}
        {showPrimaryButton && (
          <ButtonPrimary
            size="large"
            text={text_botton ?? "Tareas"}
            onClick={OnClickPrimaryButton}
          />
        )}
        {showSeccundaryButton && (
          <ButtonPrimary
            size="large"
            text={secudary_buttom_text ?? "Tareas"}
            onClick={secundary_button_onClick}
          />
        )}
        {!filter && <EllipsesMenu name="options" options={optionsMenu} />}
      </div>
    </div>
  );
};

export default NavbarFilter;
